import { Offline, Online } from "react-detect-offline";
import { useEffect } from "react";
import DefectPage from "layout/DefectPage";
import NoInternet from "assets/image/NoInternet.png";
import { RefreshRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const NoInternetConnectionPage = ({ children }) => {
  const { t } = useTranslation(["translation"]);

  const polling = {
    enabled: false,
  };
  useEffect(() => {
    let imageList = [NoInternet];
    imageList.forEach((image) => {
      new Image().src = image;
    });
  }, []);

  const propsNoInternet = {
    title: t("defect.nointernet"),
    descript: t("defect.nointernetdesc"),
    image: NoInternet,
    alt: "NoInternet",
    submit: t("refresh"),
    onSubmit: () => window.location.reload(),
    icon: <RefreshRounded />,
  };

  return (
    <>
      <Offline polling={polling}>
        <DefectPage {...propsNoInternet} />;
      </Offline>
      <Online polling={polling}>{children}</Online>
    </>
  );
};

export default NoInternetConnectionPage;
